import actions from './store/actions';
import state from './store/state';
import mutations from './store/mutations';

const store = {
  namespaced: true,

  actions,
  state,
  mutations,
};

export default store;
